import { useContext } from 'react'

import PhotoCameraOutlinedIcon from '@mui/icons-material/PhotoCameraOutlined'

import { PassContext } from "../../../pass-context"
import dataSelector from "../../data-selector"

import PopupEditor from '../../popup-editor'


const Card = ({ children, showBackgroundImage=false }) => {

  try {
    const { template, model, instanceData, scannerInstanceData, passType } = useContext(PassContext)
  
    let backgroundImage = dataSelector({ template, instanceData, scannerInstanceData, path: "meta.images.background" })

    var styles = {
      card: {
        backgroundColor: (showBackgroundImage && backgroundImage) ? "#ffffff" : model.backgroundColor
      },
      background: {
        backgroundImage: showBackgroundImage && backgroundImage ? `url(${backgroundImage})` : null,
      },
    }

    let classname = passType

    if (showBackgroundImage) classname += "_bg"

    return (
      <>
        <div style={styles.card} className="front" id="appleFront">
          <div className={classname} >
            <div style={styles.background} className="background-image"></div>
            {children}
          </div>
        </div>
        {showBackgroundImage && 
        <PopupEditor title="Background Image" path="meta.images.background">
          <PhotoCameraOutlinedIcon className='editIcon' style={{fontSize:40,position:"absolute",bottom:10,right:10}}/>
        </PopupEditor>}
      </>
    )
  }
  catch (err) {
    throw err
  }
}

export default Card